import { authAxios } from "src/libs/axios/authAxios";
import {
  ICheckTokenReq,
  ICheckUserIdReq,
  IFasooLoginCheckReq,
  IFasooLoginOtpReq,
  IFasooLoginReq,
  IJoinReq,
  ILoginReq,
  ILoginRes,
  ILogoutReq,
  IOnceLoginReq,
  ISendTokenReq,
  IWithdrawalReq,
} from "./types/sessions.type";
import { basicAxios } from "src/libs/axios/basicAxios";

// export const fasooLogin = async (req: IFasooLoginReq): Promise<any> => {
//   const response = await authAxios.post(`/sessions/fasoo/login`, req);
//   return response;
// };
// export const fasooLoginCheck = async (
//   req: IFasooLoginCheckReq
// ): Promise<any> => {
//   const response = await authAxios.post(`/sessions/fasoo/login/check`, req);
//   return response;
// };
// export const fasooLoginOtp = async (req: IFasooLoginOtpReq): Promise<any> => {
//   const response = await authAxios.post(`/sessions/fasoo/login/otp`, req);
//   return response;
// };

// 로그인
export const login = async (req: ILoginReq): Promise<ILoginRes> => {
  const response = await basicAxios.post(`/sessions/login`, req, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};
// UUID 기반 로그인
export const onceLogin = async (req: IOnceLoginReq): Promise<ILoginRes> => {
  const { uuid, site } = req;
  const response = await basicAxios.post(
    `/sessions/oncelogin/${uuid}${site ? `?site=${site}` : ""}`
    //   {
    //   headers: { "Content-Type": "application/x-www-form-urlencoded" },
    // }
  );
  return response.data;
};
// 로그아웃
export const logout = async (req: ILogoutReq): Promise<any> => {
  const response = await authAxios.post(`/sessions/logout`, req);
  return response;
};
// 회원가입
export const join = async (req: IJoinReq): Promise<any> => {
  const response = await basicAxios.post(`/sessions/join`, req);
  return response;
};
// 이메일 인증
export const sendToken = async (req: ISendTokenReq): Promise<any> => {
  const response = await basicAxios.post(`/sessions/join/token`, req);
  return response;
};
// 인증번호 확인
export const checkToken = async (req: ICheckTokenReq): Promise<any> => {
  const response = await basicAxios.post(`/sessions/check/token`, req);
  console.log("checkToken", response);
  return response;
};
// 유저 중복확인
export const checkUserId = async (req: ICheckUserIdReq): Promise<any> => {
  const response = await basicAxios.post(`/sessions/check/userid`, req);
  return response;
};

export const withdrawal = async (req: IWithdrawalReq): Promise<any> => {
  const response = await authAxios.post(`/sessions/withdrawal`, req);
  return response.data;
};
